




















import { Vue, Component, State, namespace, Watch, Prop, Ref } from 'nuxt-property-decorator'
import { Experience } from '~/types/experience'

import TreeNode = Experience.TreeNode
import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component

export default class CategoryTree extends Vue {
  @State klook!: Data.Klook
  @Prop() categoryTreeData!: TreeNode[]
  @Prop({ default: false }) expandAll!: boolean
  @experience.Action setUrlQuery!: Function
  @experience.Action setSelectedCategory!: Function
  @experience.Action setExpandNode!: Function
  @experience.State pageType!: string
  @experience.State urlQuery!: UrlQuery
  @Ref() tree!: Vue

  @Prop({ default: false }) inModal!: boolean

  get spm() {
    const category = this.urlQuery.frontend_id_list && { categorytree_id: this.urlQuery.frontend_id_list }
    const spm = `CategoryFilter?trg=manual&ext=${JSON.stringify(category)}`
    return spm
  }

  @Watch('categoryTreeData')
  categoryTreeDataChange() {
    this.category = JSON.parse(JSON.stringify((this.categoryTreeData)))
  }

  category: any = null

  expandChange(node: TreeNode) {
    if (!this.inModal) {
      this.setExpandNode(node)
    }
  }

  setCategoryData() {
    const obj: any = {}
    this.category.forEach((category: TreeNode) => {
      if (category.checked) {
        obj[category.id] = category
      } else if (category.children) {
        category.children.forEach((child: TreeNode) => {
          child.checked && (obj[child.id] = child)
        })
      }
    })
    return obj
  }

  async change() {
    const obj = this.setCategoryData()
    if (this.inModal) {
      this.$emit('change', {
        selected: obj,
        category: this.category
      })
      return null
    }
    this.setSelectedCategory(JSON.parse(JSON.stringify(obj)))
    const category = Object.keys(obj).join(',')

    await this.setUrlQuery({
      frontend_id_list: category,
      page: 1
    })

    // todo 暂时屏蔽 ga 的上报，待组件库完善功能后再上
    // this.checkGtm(node, isCheck)
    if (this.inModal) {
      return null
    }
    const moduleTree = document.querySelector('.js-category-tree-spm') as HTMLElement
    this.$inhouse.updateBinding(moduleTree, {
      ext: JSON.stringify({ categorytree_id: category })
    })
    this.$inhouse.track('action', this.tree.$el)
  }

  checkGtm(node: TreeNode, isCheck: boolean) {
    if (isCheck) {
      const id = node.id
      const content = this.pageType === 'search'
        ? `Experience SearchResult|ExperienceSearchResult_Categroy_Clicked|levei_${id}`
        : `Experience Category|ExperienceCategory_Categroy_Clicked|levei_${id}`
      this.$sendGTMCustomEvent(content)
    }
  }

  mounted() {
    this.category = JSON.parse(JSON.stringify((this.categoryTreeData)))
    const obj = this.setCategoryData()
    if (!this.inModal) {
      this.setSelectedCategory(JSON.parse(JSON.stringify(obj)))
    }
  }
}
